import type {
  InterviewQuestion,
  InterviewType,
  ParseCombinedResult,
  ParseQuestionsResult,
  ParseTypesResult,
} from "@scoach/types";

import { api } from "../../lib/http.ts";

interface CommitResult {
  imported: number;
  warnings: { row: number; message: string }[];
}

interface CombinedCommitResult {
  importedQuestions: number;
  importedTypes: number;
  warnings: { row: number; message: string }[];
}

function fd(file: File): FormData {
  const f = new FormData();
  f.append("file", file, file.name);
  return f;
}

export const interviewAdminApi = {
  parseCombined: (file: File) =>
    api<ParseCombinedResult>("/admin/interview/combined/parse", { method: "POST", body: fd(file) }),
  commitCombined: (file: File) =>
    api<CombinedCommitResult>("/admin/interview/combined/commit", { method: "POST", body: fd(file) }),

  parseQuestions: (file: File) =>
    api<ParseQuestionsResult>("/admin/interview/questions/parse", { method: "POST", body: fd(file) }),
  commitQuestions: (file: File) =>
    api<CommitResult>("/admin/interview/questions/commit", { method: "POST", body: fd(file) }),
  listQuestions: () =>
    api<{ questions: InterviewQuestion[] }>("/admin/interview/questions").then((r) => r.questions ?? []),
  deleteQuestion: (id: string) =>
    api<{ ok: boolean }>(`/admin/interview/questions/${id}`, { method: "DELETE" }),

  parseTypes: (file: File) =>
    api<ParseTypesResult>("/admin/interview/types/parse", { method: "POST", body: fd(file) }),
  commitTypes: (file: File) =>
    api<CommitResult>("/admin/interview/types/commit", { method: "POST", body: fd(file) }),
  listTypes: () => api<{ types: InterviewType[] }>("/admin/interview/types").then((r) => r.types ?? []),
  deleteType: (id: string) =>
    api<{ ok: boolean }>(`/admin/interview/types/${id}`, { method: "DELETE" }),
};
